import React from "react";
import making from "../videos/mak.mp4"

const videoData = [
  {
    title: "Baking Our Signature Cake",
    file: require("../videos/mak.mp4"),
  },
  {
    title: "Making Fresh Bread",
    file: require("../videos/mak.mp4"),
  },
  {
    title: "Behind the Scenes",
    file: require("../videos/mak.mp4"),
  },
  {
    title: "Behind the Scenes",
    file: require("../videos/mak.mp4"),
  },
  {
    title: "Behind the Scenes",
    file: require("../videos/mak.mp4"),
  },
];

const Videos = () => {
  return (
    <section className="videos-section" id="videos">
      <h2 className="videos-title">Baking in Action</h2>
      <div className="video-grid">
        {videoData.map((video, index) => (
          <div className="video-card" key={index}>
            <video controls preload="metadata">
              <source src={video.file} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
            <p>{video.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Videos;
